/**
 * What the hub's scales typed into a Box's weight field, read as kilograms (spec §12,
 * ADR-0047 — the Hub weight, the one weighing in the network). Scales behave as a
 * keyboard, and a person may type a comma for the decimal point, so both are read. A
 * weight is above zero and at most a tonne — the same bounds `hubReceiving.ReceiveBox`
 * and `OpenBox` hold (anything else is a mistyped scan, not a Box); `null` when the
 * field does not hold one.
 */
export function readHubWeight(raw: string): number | null {
	const text = raw.trim().replace(',', '.')
	if (!/^\d+(\.\d+)?$|^\.\d+$/.test(text)) return null
	const kg = Number(text)
	if (!Number.isFinite(kg) || kg <= 0 || kg > 1000) return null
	return kg
}
